module.exports = __webpack_public_path__ + "fonts/Golos-Text_Black.e7b5510.eot";